import React from 'react';

/**
 * Utility class for Model related helper functions
 * Includes all UI side rules as well
 */
export class ModelHelper {

    /**
     * Validate the model before saving
     */
    static validateModel = (params) => {
        let errors;

        params.parameters.forEach(function (tab) {
            return tab.parameter.forEach(function(param) {
                if (param.parameterGroup === 'Margin & Profitability Assumptions' && param.parameterName === 'Medicaid FFS Margin $') {
                    if (param.parameterValue === '') param.parameterValue = 0;
                }
                if (typeof param.parameterValue !== 'number') {
                    errors = "Invalid value detected in field " + param.parameterName + ".";
                }
            })
        })
        
        if (errors) {
            return errors
        }


        var payorMixGroup = params.parameters.find(pg => pg.group === "Payer Mix Parameters");
        if (payorMixGroup) {
            var commercial = payorMixGroup.parameter.find(p => p.parameterName === "Commercial % Claims");
            var medicare = payorMixGroup.parameter.find(p => p.parameterName === "Medicare % Claims");
            var medicaid = payorMixGroup.parameter.find(p => p.parameterName === "Medicaid Non-FFS % Claims");
            var medicaidFfs = payorMixGroup.parameter.find(p => p.parameterName === "Medicaid FFS % Claims");
            var selfpay = payorMixGroup.parameter.find(p => p.parameterName === "Self-Pay % Claims");
            var other = payorMixGroup.parameter.find(p => p.parameterName === "Other % Claims");
            if (commercial && medicare && medicaid && medicaidFfs && selfpay && other) {
                var total = commercial.parameterValue + medicare.parameterValue
                    + medicaid.parameterValue + medicaidFfs.parameterValue
                    + selfpay.parameterValue + other.parameterValue;
                if (total !== 100.0) {
                    errors = "Payer Mix Parameters must add up to 100% (current is " + total + "%)";
                }
            }
        }

        return errors;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Model Input Variables - computed fields

    /**
     * Called during rendering of Model Input Variable grid to insert computed columns
     */
    static renderComputedVariables(variable, columns) {
        if (variable.variableName === this._rxPerPatient) {
            this.insertComputedVariables(columns);
        }
    }

    static insertComputedVariables(columns) {
        let col = {
            Header: () => (<div style={{ textAlign: "center", color: "#166c9d" }}>Rx Per Physician</div>),
            accessor: this._rxPerPhysician,
            className: "td-computed",
        };
        columns.push(col);
        col = {
            Header: () => (<div style={{ textAlign: "center", color: "#166c9d" }}>Total Scripts</div>),
            accessor: this._totalScripts,
            className: "td-computed",
        };
        columns.push(col);
    }

    static initializeComputedVariables(data) {
        for (const r in data) {
            this.recalcComputedVariables(data, r, 'patients');
        }
    }

    /**
     * rowidx and colidx of changed cell
     */
    static recalcComputedVariables(data, rowidx, colidx) {

        if (colidx === 'patients' || colidx === 'treatments' || colidx === 'rxPatient' || colidx === 'employed' || colidx === 'nonEmployed') {
            data[rowidx][this._rxPerPhysician] = data[rowidx]['patients'] * data[rowidx]['treatments'] * data[rowidx]['rxPatient'];
            data[rowidx][this._totalScripts] = data[rowidx]['rxPerPhysician'] * (data[rowidx]['employed'] + data[rowidx]['nonEmployed']);
        }
    }

    static filterComputedVariables(variables) {
        let filteredVars = [];
        variables.forEach(v => {
            // create new object with filtered out computed attributes
            let nv = {};
            for (var k in v) {
                if (this._computedVariables.indexOf(k) === -1) {
                    nv[k] = v[k];
                }
            }
            filteredVars.push(nv);
        });
        return filteredVars;
    }

    static _rxPerPatient = 'RX / Patient';
    static _rxPerPhysician = 'rxPerPhysician';
    static _totalScripts = 'totalScripts';
    static _computedVariables = [ModelHelper._rxPerPhysician, ModelHelper._totalScripts];

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

}
